export const DEVELOP_START_LINK = "https://t.me/TestIzebBot";
export const PROD_START_LINK = "https://t.me/FitGuid_bot";
